/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ValidateHandlingOrderAliases {
  FORM_FETCH_AUXILIAR = 'form-fetch-auxiliar',
  VALIDATE_HANDLING_ORDER_BARCODE = 'validate-handling-order-barcode',
  VALIDATE_HANDLING_ORDER_BARCODE_PANEL = 'validate-handling-order-barcode-panel',
  VALIDATE_HANDLING_ORDER_LAYOUT = 'validate-handling-order-layout',
}
export { ValidateHandlingOrderAliases };
